import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { normalizeAuthUser } from "../../utils/authUser";

export const useFetchProfile = () => {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const res = await api.get("/auth/profile");
      // return the raw profile object so Profile page can read every field
      const raw =
        res.data?.data?.company ||
        res.data?.data?.user    ||
        res.data?.company       ||
        res.data?.user          ||
        res.data?.data          ||
        res.data                ||
        {};
      return raw;
    },
    staleTime: 60_000,
  });
};
